<div class="bulk-import">


  <h2>Bulk import clients</h2>


  <p>
    <a target="_blank" href="/assets/Bulk client import_sample.xlsx">Download sample file</a>
  </p>

  <div>
    <p>Spreadsheet requirements. Microsoft XLSX.</p>
    <ul>
      <li>Client Name: Name of client to import</li>
      <li>Client Type: one of EDUCATION, LAW, FINANCE, OTHER</li>
      <li>Education Group (optional): Name of an existing client that will be the parent client for the new imported
        client.</li>
      <li>Contract start date: must be format DD.MM.YYYY e.g. 13.01.2024 or 13/01/2024</li>
      <li>Contract expiry date: must be format DD.MM.YYYY e.g. 13.01.2024 or 13/01/2024</li>
      <li>School level: one of PRIMARY, SECONDARY, BOTH</li>
      <li>Template description: Comma separated list of description(s) for existing code(s) that are template(s).</li>
      <li>Lead emails: Comma separated list of emails that will be made HR users for this client.</li>
      <li>Expected users (optional): integer number of users expected for the newly added code(s)</li>
      <li>Expected completion date (optional): must be format DD.MM.YYYY eg 13.01.2024. Cannot be another format.</li>
    </ul>
  </div>

  @if (!clientCount && !processing) {
  <form style="display:flex;justify-content:space-between;" [formGroup]="bulkForm" (submit)="onSubmit()">
    <input type="file" formControlName="file" (change)="onFileSelected($event)" />

    <div style="display:flex;">
      <button type="submit">Upload</button>
      <button (click)="onClose()" style="margin-left:10px;">Cancel</button>
    </div>
  </form>
  }

  @if (errors) {
  <div class="errors">
    <p>The following errors were detected in<br /> <strong>{{selectedFile.name}}</strong></p>
    <ul>
      @for (error of errors; track error) {
      <li>{{error}}</li>
      }
    </ul>
  </div>
  }

  @if (clientCount && !processing) {
  <div>
    <p>Import {{clientCount}} clients?</p>
    <p>
      <label for="importEmail">Email guides to leads/HR users:</label>
      <select (change)="onEmailChange($event)">
        <option value="0">Do not email</option>
        @for (item of sendgridTemplateIds; track item) {
        <option [value]="item.value">{{item.label}}</option>
        }
      </select>
    </p>
    <div class="importButtons">
      <button (click)="onImport()">Yes</button>
      <button (click)="onClose()">No</button>
    </div>
  </div>
  }

  @if (processing) {
  <div class="processing">
    Processing, please wait...
  </div>
  }

</div>